export const ORG_TYPE_KINDS = {
  ACCOUNT_TYPES: 'account-types',
  BRANCH_TYPES: 'branch-types',
  AREA_TYPES: 'area-types',
  VENUE_TYPES: 'venue-types',
  POSITION_TYPES: 'position-types'
};

export const BRANCH_TYPE_SCOPED_KINDS = [ORG_TYPE_KINDS.AREA_TYPES, ORG_TYPE_KINDS.POSITION_TYPES];
